import copy_clipboard from '~/assets/js/functions/copy_clipboard';
import useToast from '~/assets/js/composables/layout/useToast';

const useShare = () => {
  const shareLink = async (link, title = null, text = null) => {
    try {
      navigator.share({
        ...(title && { title }),
        ...(text && { text }),
        url: link,
      });
    } catch (error) {
      if (copy_clipboard(link)) {
        useToast().create_success('کپی شد');
      } else {
        useToast().create_danger('مشکلی در اشتراک گذاری رخ داده است');
      }
      console.error('Error sharing text:', error);
    }
  };

  return {
    shareLink,
  };
};

export default useShare;
